import { observer } from 'mobx-react-lite';
import { ProductFruits } from 'react-product-fruits';

import { getEnvVar } from '@/env';
import { userStore } from '@/stores/user.store';

export const ProductFruitsWrapper = observer(() => {
  const user = userStore.user;
  const workspaceCode = getEnvVar('VITE_PRODUCT_FRUITS_WORKSPACE_CODE');

  if (!workspaceCode || !user) {
    return null;
  }

  const nameParts = user.name?.trim().split(' ') || [];
  const firstname = nameParts[0] || '';
  const lastname = nameParts.slice(1).join(' ') || '';

  const userInfo = {
    username: user.sub,
    email: user.email,
    firstname,
    lastname,
    signUpAt: user.created_at || new Date().toISOString(),
    role: user.feature_access || 'user',
    props: {
      total_inputs: user.total_inputs,
      feature_access: user.feature_access,
    },
  };

  return (
    <ProductFruits
      workspaceCode={workspaceCode}
      language="en"
      user={userInfo}
    />
  );
});
